import SignUpAnimation from 'components/animations/SignUpAnimation';
import SplitScreenComponent from 'components/containers/SplitScreenComponent';
import SignUpFlow from 'components/generics/flows/LoginSignUpFlow/SignUpFlow';
import PublicOnly from 'hocs/PublicOnly';
import React from 'react';
import classes from './index.module.scss';

const SignupPage = () => {
  return (
    <SplitScreenComponent
      LeftComponent={<SignUpAnimation />}
      RightComponent={<SignUpFlow tenant={false} />}
      rightContainerClassName={classes.rightContainer}
      leftContainerClassName={classes.leftContainer}
      rightContentClassName={classes.rightContent}
    />
  );
};

export default PublicOnly(SignupPage);
